const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  apiKey: process.env.REACT_APP_API_KEY,
  useMocks: process.env.REACT_APP_USE_MOCKS === 'true',
  awsRegion: process.env.REACT_APP_AWS_REGION || 'us-east-1',
};

export default config;
